import { Component, Input } from '@angular/core';
import { Action, AvailableActions } from '../../../models/monitoring-tasks/AvailableActions';
import { MonitorTaskStatusEnum } from '../../../models/price-monitoring-task/enums/MonitorTaskStatusEnum';
import { MatDialog } from '@angular/material/dialog';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { TranslateService } from '@ngx-translate/core';
import { TaskActionData } from '../../../models/monitoring-tasks/TaskActionData';
import { SubmitReasonComponent } from '../../submit-reason/submit-reason.component';
import { FieldTypes } from 'projects/shared/src/models/global/FieldTypes';
import { MonitorTaskDetails } from '../../../models/price-monitoring-task/MonitorTaskDetails';
import { MonitorTaskService } from '../../../services/monitor-task.service';
import { SystemTaskTypeEnum } from '../../../models/price-monitoring-task/enums/SystemTaskTypeEnum';
import { RunAiProcessComponent } from './run-ai-process/run-ai-process.component';

@Component({
  selector: 'app-price-monitoring-tasks-actions',
  standalone: false,
  templateUrl: './price-monitoring-tasks-actions.component.html'
})
export class PriceMonitoringTasksActionsComponent {
  @Input({ required: true }) record: MonitorTaskDetails = new MonitorTaskDetails();
  @Input() isAmbassador: boolean = false;
  @Input() assignedTaskType: SystemTaskTypeEnum = SystemTaskTypeEnum.Manual;
  availableActions: AvailableActions = new AvailableActions();
  monitorTaskStatusEnum = MonitorTaskStatusEnum;
  loading = false

  constructor(
    public dialog: MatDialog,
    private swalService: SwalService,
    private translate: TranslateService,
    private service: MonitorTaskService
  ) { }

  ngOnInit() {
    this.getAvailableActions();
  }

  getAvailableActions() {
    this.service.getAvailableActions(this.record.taskId).subscribe((data) => {
      this.availableActions = data as AvailableActions;
    }, (error: any) => {

    })
  }

  handleClick(action: Action) {
    switch (action.apiName) {
      case 'ChangeTaskStatus':
        this.ChangeTaskStatus(action);
        break;
      case 'RunAi':
        this.runAi(action);
        break;
      default:
        let data = {
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          actionId: action.actionId,
          reason: ""
        }
        break;
    }
  }

  ChangeTaskStatus(action: Action) {
    let data = {} as TaskActionData;
    switch (action.nextStatus) {
      case MonitorTaskStatusEnum.Modifications_Requested_From_First_Review:
      case MonitorTaskStatusEnum.Modifications_Requested_From_Final_Review:
      case MonitorTaskStatusEnum.Final_Report_Rejected:
        this.requestEdit(action);
        break;
      default:
        data = {
          actionId: action.actionId,
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          reason: ""
        };
        let title = this.translate.instant('swalMsg.Success');
        if (action.nextStatus === MonitorTaskStatusEnum.Waiting_First_Review && action.currentStatus === MonitorTaskStatusEnum.Modifications_Requested_From_First_Review) {
          title = this.translate.instant('monitoringTasks.taskResubmittedForReviewSuccessfully');
        } else if (action.nextStatus === MonitorTaskStatusEnum.Waiting_First_Review) {
          title = this.translate.instant('monitoringTasks.priceMonitoringDataSubmittedForReviewSuccessfully');
        } else if (action.nextStatus === MonitorTaskStatusEnum.Waiting_Final_Review) {
          title = this.translate.instant('monitoringTasks.priceMonitoringResultsApprovedSuccessfully');
        } else if (action.nextStatus === MonitorTaskStatusEnum.Waiting_Final_Approval) {
          title = this.translate.instant('monitoringTasks.priceMonitoringTaskApprovedSuccessfully');
          // } else if (action.nextStatus === MonitorTaskStatusEnum.Final_Report_Rejected) {
          //   title = this.translate.instant('monitoringTasks.finalResultsRejectedSuccessfully');
        } else if (action.nextStatus === MonitorTaskStatusEnum.Final_Report_Approved) {
          title = this.translate.instant('monitoringTasks.finalResultsApprovedSuccessfully');
        }
        this.confirmationAction(data, title);
        break;
    }
  }

  runAi(action: Action) {
    let title = this.translate.instant('swalMsg.aiMonitoringStartedSuccessfully');
    if (action.currentStatus === MonitorTaskStatusEnum.Modifications_Requested_From_First_Review) {
      title = this.translate.instant('swalMsg.aiMonitoringStartedSuccessfully');
    }
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousure')).then((result) => {
      if (result.value) {
        this.openDialogProgress(title);
        // this.loading = true;
        // this.service.runAi(this.record.taskId).subscribe(
        //   (res: any) => {
        //     this.loading = false;
        //     this.service.refreshDetails.next(true);
        //     this.swalService.swalSuccess('', this.translate.instant('swalMsg.Ok'), title);
        //   },
        //   (err: any) => {
        //     this.loading = false;
        //     this.handleErrors(err.detail);
        //   }
        // );
      }
    });
  }

  openDialogProgress(title: string) {
    // console.log(data)
    this.loading = true;
    const dialogRef = this.dialog.open(RunAiProcessComponent, {
      width: '540px',
      disableClose: true,
      data: {
        taskId: this.record.taskId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.loading = false;
      console.log(result)
      if (result) {
        this.service.refreshDetails.next(true);
        this.swalService.swalSuccess('', this.translate.instant('swalMsg.Ok'), title);
      }
    });
  }

  requestEdit(action: Action) {
    const rejectRequest = action.nextStatus === MonitorTaskStatusEnum.Final_Report_Rejected;
    const dataRecord = {
      title: this.translate.instant('monitoringTasks.' + (rejectRequest ? 'rejectRequest' : 'modificationRequest')),
      btnSubmitTitle: this.translate.instant('general.confirm'),
      showClose: true,
      service: this.service,
      serviceTarget: 'changeTaskStatus',
      hideSwalMessageSuccess: true,
      record: {
        actionId: action.actionId,
        taskId: this.record.taskId,
        nextStatus: action.nextStatus
      },
      fields: [
        {
          id: 'reason',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: rejectRequest ? this.translate.instant('monitoringTasks.rejectionReason') : this.translate.instant('rights.editRequestReason'),
          value: null,
          isMandatory: true,
          fieldLength: 1000,
          minLength: 3
        }
      ],
    };
    let title = this.translate.instant('monitoringTasks.modificationRequestSentSuccessfully');
    if (rejectRequest) {
      title = this.translate.instant('monitoringTasks.finalResultsRejectedSuccessfully');
    }
    this.openForm(dataRecord, title);
  }

  openForm(dataRecord: any, title: string, message = '') {
    const dialogRef = this.dialog.open(SubmitReasonComponent, {
      width: '540px',
      data: dataRecord,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.service.refreshDetails.next(true);
        this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
      }
    });
  }

  confirmationAction(data: TaskActionData, title: string = this.translate.instant('swalMsg.Success'), message = '') {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousure')).then((result) => {
      if (result.value) {
        this.loading = true;
        // const formData = new FormData();
        // formData.append('data', JSON.stringify(data));
        this.service.changeTaskStatus(data).subscribe(
          (res: any) => {
            this.loading = false;
            this.service.refreshDetails.next(true);
            this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
          },
          (err: any) => {
            this.loading = false;
            this.handleErrors(err.detail);
          }
        );
      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }
}
